import { useReducedMotion as useFramerReducedMotion } from 'framer-motion';
import useIsClientSide from './useIsClientSide';

// This hook is used when the reduced motion condition affects various styles
// on different components and we want to make sure those styles are only applied
// on the client side, avoiding any mismatch between server and client rendering.
const useReducedMotion = () => {
  const isClientSide = useIsClientSide();
  const prefersReducedMotion = useFramerReducedMotion();

  return prefersReducedMotion && isClientSide;
};

export default useReducedMotion;
